"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Aug 22 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * CompetitorPriceConverter
 *
 * @author RV
 */


var CompetitorPriceConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorPriceConverter, _DataObjectConverter_);

  function CompetitorPriceConverter() {
    _classCallCheck(this, CompetitorPriceConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceConverter).apply(this, arguments));
  }

  return CompetitorPriceConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorPriceConverter = CompetitorPriceConverter;